import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Moment, isMoment } from 'moment';

export const datePattern = /(^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$)/;

/**
  INFO: Custom Reactive Form Validator (dates with moment object)
  this.reactiveForm = this.fb.group({
    field_date: [moment(field_date) : null, datePickerValidator()]
  });
* */
export function datePickerValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let isValid = true;
    if (control.value) {
      const dateToString: string = datePickerFormat(control.value, 'DD/MM/YYYY');
      isValid = datePattern.test(dateToString);
    }
    return isValid ? null : { 'invalidDateFormat': true };
  };
}

/**
  INFO: Transforms the date format of a field when is a moment obj
  .pipe(
    map((changes) => datePickerFormat(changes))
  )
  Returns strings when the field was formatted or the field type when it wasn't a moment obj
* */
export function datePickerFormat(field: string | Moment, dateFormat: string = 'YYYY-MM-DD'): string | any {
  if (field) {
    if (isMoment(field)) {
      return field.format(dateFormat);
    }
    return field;
  }
  return null;
}
